import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { connect } from 'react-redux';
import { fetchTrade } from '@Header/ducks/operations';
import { fetchPurchaseDetails } from '@Header/Account/ducks/operations';
import { selectPurchaseDetailsRequestStatus } from '@Header/Account/ducks/selectors';
import MenuLine from '../../Shared/MenuLine';
import Trade from './Trade';
import MyCarvana from './MyCarvana';
import MobileDropdownArrow from '../../Shared/MobileDropdownArrow';
import Icon from '../../Shared/Icons';
import Purchase from './Purchase';
import PostSale from './PostSale/PostSaleWrapper';
import { logOut } from '../ducks/actions';
import Reservation from './Reservation';
import { isOnTradesSummary, IsPurchaseProcess } from '../../utilities';
import { postSaleSelectors } from './PostSale/ducks';
import {
  DropdownButton,
  DropdownWrapper,
  InnerDrawerItem,
  ProfileName,
  SignOut,
  StyledAccountCircle,
  StyledMenuButton,
  StyledMenuDrawerItem,
  SvgWrapper,
  GoogleOneTapForceSignoutWrapper
} from './ProfileMobile.styles';

class Profile extends PureComponent {
  static contextType = AnalyticsContext;

  static propTypes = {
    fetchTrades: PropTypes.func.isRequired,
    purchaseDetailsRequestStatus: PropTypes.shape({}).isRequired,
    profile: PropTypes.shape({ profileFirstName: PropTypes.string }).isRequired,
    isTradeRequestCompleted: PropTypes.bool.isRequired,
    isUserInPostSale: PropTypes.bool.isRequired,
    useModalUrlForAccountLinks: PropTypes.bool.isRequired,
    fetchPurchaseDetails: PropTypes.func.isRequired,
    logOut: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      isExpanded: false,
      hasFetchedData: false,
      hasFetchedSummary: false
    };

    this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }

  getTrades() {
    const { fetchTrades, isTradeRequestCompleted } = this.props;
    if (isTradeRequestCompleted) {
      this.setState({ hasFetchedData: true });
      return;
    }
    fetchTrades();
  }

  getPurchaseDetails() {
    const { fetchPurchaseDetails, purchaseDetailsRequestStatus } = this.props;
    const { isLoading, isError } = purchaseDetailsRequestStatus;
    if (!isLoading && !isError) {
      return;
    }
    fetchPurchaseDetails('purchase/details');
  }

  toggleDropdown(isDropdownExpanded) {
    this.setState({ isDropdownExpanded });
  }

  async logOut() {
    const { logOut: logOutAction, useModalUrlForAccountLinks } = this.props;
    await logOutAction();
  }

  handleExpansionToggle() {
    const { isExpanded } = this.state;
    const { trackEvent } = this.context;

    if (!isExpanded) {
      this.getTrades();
      this.getPurchaseDetails();
      trackEvent('user platform - header - expanded profile menu', { platform: 'mobile' });
    }
    this.setState({ isExpanded: !isExpanded });
  }

  render() {
    const { isExpanded, hasFetchedData, hasFetchedSummary } = this.state;
    const {
      profile: { profileFirstName },
      isUserInPostSale,
      purchaseDetailsRequestStatus,
    } = this.props;
    const shouldShowTrade = !IsPurchaseProcess() && !isOnTradesSummary();
    return (
      <StyledMenuDrawerItem>
        <InnerDrawerItem isExpanded={isExpanded}>
          <StyledMenuButton
            dataCvTest="headerMobileProfileExpand"
            onClick={this.handleExpansionToggle}
          >
            <SvgWrapper>
              <StyledAccountCircle>
                <Icon iconName="profile" />
              </StyledAccountCircle>
            </SvgWrapper>
            <ProfileName>{profileFirstName || 'Account'}</ProfileName>
            <MobileDropdownArrow isExpanded={isExpanded} />
          </StyledMenuButton>
          <DropdownWrapper>
            <DropdownButton
              href="/account"
              target="_self"
              eventName="user platform - header - clicked my account"
              eventData={{ platform: 'mobile' }}
            >
              My Account
            </DropdownButton>
            <MenuLine />
            <Reservation />
            <Purchase
              isPurchaseRequestInProgress={
                purchaseDetailsRequestStatus.isLoading
              }
            />
            {isUserInPostSale && <PostSale />}
            {shouldShowTrade && <Trade hasFetchedData={hasFetchedData} />}
            <MenuLine />
            <MyCarvana />
            <SignOut
              onClick={() => this.logOut()}
              eventName="user platform - header - clicked sign out"
              eventData={{ platform: 'mobile' }}
            >
              <GoogleOneTapForceSignoutWrapper className="g_id_signout">
                Sign Out
              </GoogleOneTapForceSignoutWrapper>
            </SignOut>
          </DropdownWrapper>
        </InnerDrawerItem>
      </StyledMenuDrawerItem>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  fetchTrades: () => dispatch(fetchTrade()),
  fetchPurchaseDetails: url => fetchPurchaseDetails(url)(dispatch),
  logOut: () => dispatch(logOut())
});

const mapStateToProps = state => ({
  isTradeRequestCompleted: state.header.header.isTradeRequestCompleted,
  useModalUrlForAccountLinks: state.header.header.useModalUrlForAccountLinks,
  isUserInPostSale: postSaleSelectors.getIsUserInPostSale(state),
  purchaseDetailsRequestStatus: selectPurchaseDetailsRequestStatus(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
